module.exports = __webpack_public_path__ + "media/images/home/sales_crm-d99985976fa8ca7e8fb435538a5af841.svg";